import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { PER_PAGE_SELECT_OPTIONS } from '../../../../config';

import SpinnerBlock from '../../../common/SpinnerBlock';
import TableRow from './TableRow';
import Pagination from '../../../common/Pagination';
import { useAutoTranslation } from './../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  margin-top: 24px;
  .fixed-table-body {
    border-bottom: 1px solid #dee2e6;
  }
  .table {
    width: 100%;
    margin-bottom: 0;
    min-width: 800px;
    .right {
      text-align: right;
    }
  }
  .table tr {
    padding-top: 7px;
    padding-bottom: 7px;
    color: #323a46;
  }
  .table .thead-light th {
    padding-top: 9px;
    padding-bottom: 9px;
    height: 60px;
    font-size: 14px;
    span {
      font-weight: 500;
    }
  }
  strong {
    display: block;
    font-weight: 500;
  }
  .text-muted {
    color: #98a6ad;
  }
  .red {
    color: #f1556c;
  }
`;

const ReportTable = (props) => {
  const {
    loading,
    items,
    THEAD_ITEMS,
    totalItems,
    page,
    handlePageSelect,
    perPageCount,
    setPerPageCount,
    urlSearchStr,
  } = props;

  const { t } = useAutoTranslation();

  const handlePerPageSelect = (count) => {
    setPerPageCount(count);
    handlePageSelect(0);
  };

  return (
    <>
      <Wrapper>
        <div className="fixed-table-container">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <Fragment>
                    {THEAD_ITEMS.map((item) => (
                      <th className={item.class ? item.class : null}>
                        <div>{t(item.title)}</div>
                      </th>
                    ))}
                  </Fragment>
                </tr>
              </thead>
              {!loading ? (
                <tbody>
                  {items.length ? (
                    items.map((item) => (
                      <>
                        <TableRow key={item.id} item={item} urlSearchStr={urlSearchStr} t={t} />
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">{t('Ничего не найдено')}</td>
                    </tr>
                  )}
                </tbody>
              ) : null}
            </table>
            {loading ? (
              <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                <SpinnerBlock show={loading} />
              </div>
            ) : null}
          </div>
        </div>
        <Pagination
          withPerPageCountSelect
          total={totalItems}
          currentPage={Number(page)}
          perPage={perPageCount}
          onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
          onPerPageSelect={(count) => handlePerPageSelect(count)}
          perPageSelectOptions={PER_PAGE_SELECT_OPTIONS}
        />
      </Wrapper>
    </>
  );
};

export default ReportTable;
